module.exports = __webpack_public_path__ + "static/media/pendiente-marker.1c9dc41f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/img/pendiente-marker.svg
// module id = 874
// module chunks = 0